import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {NameValueDTO} from 'src/app/modules/common/models/NameValueDTO';
import {environment} from 'src/environments/environment';
import {FileDTO} from '../models/FileDTO';

@Injectable({
  providedIn: 'root'
})
export class FileService {
  private url = environment.baseUrl + '/file';

  constructor(private httpClient: HttpClient) {
  }

  getFile(id: number): Observable<FileDTO> {
    return this.httpClient.get<FileDTO>(this.url + '/' + id);
  }

  promptBrowserFileDownloadFromFileDTO(response: FileDTO) {
    const csvContent = atob(response.file);
    const blob = new Blob([csvContent], {type: 'data:application/octet-stream;base64'});
    this.prepareBlobForDownload(csvContent, response.name + response.extension);
  }

  promptBrowserFileDownloadFromDataObject(data: any, fileName: string, ignoreAuditFields = true) {
    const header = Object.keys(data[0]);
    const auditFields = ['created', 'createdBy', 'updated', 'updatedBy', 'tenantId'];
    if (ignoreAuditFields) {
      auditFields.forEach(auditField => {
        const index = header.findIndex(headerColumn => headerColumn === auditField);
        if (index > -1) {
          header.splice(index, 1);
        }
      });
    }
    const csv = data.map(row => header.map(fieldName => row[fieldName] == null ? '' : row[fieldName]).join(';'));
    csv.unshift(header.join(';'));

    const csvContent: string = csv.join('\r\n');
    this.prepareBlobForDownload(csvContent, fileName);
  }

  private prepareBlobForDownload(csvContent, fileName: string) {
    const blob = new Blob([csvContent], {type: 'data:application/octet-stream;base64'});
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }
}
